import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./List";
import Upload from "./Upload";
import Summary from "./Summary";
import SubDocuments from "./SubDocuments";
function Documents({ match }) {
  const { path } = match;

  return (
    <Switch>
      <Route exact path={`${path}`} component={List} />
      <Route path={`${path}/upload`} component={Upload} />
       <Route path={`${path}/:id/summary`} component={Summary} />
       <Route path={`${path}/:id/sub-documents`} component={SubDocuments} />
    </Switch>
  );
}

export { Documents };
